import React from 'react';
import { useSelector } from 'react-redux';
import { WholeState } from '../../store/common/type';
import { DDListingsResponse, buildDDUrl } from '../../lib/ddListingTypes';
import {
  getDeveloperListing,
  getAgentListings,
  getProjectName,
  getListingIdentifier,
} from './utility/ddListingsHelpers';
import UnitTypesFromDeveloper from './UnitTypesFromDeveloper';
import UnitsFromAgent from './UnitsFromAgent';
import {
  DDListingsWrapper,
  DDListingsDivider,
  DDSectionTitle,
  ViewDetailsButton,
  ViewDetailsButtonWrapper,
} from './DDListingsModule.style';
import { ExternalLinkIcon } from './assets/ExternalLinkIcon';
import { trackDDListingClick } from '../../common/analytics/analyticsTracker';
import { ADP } from '../../common/analytics/sourceTypes';
import { ANALYTICS_FEATURES } from '../../common/analytics/featureTypes';

interface Props {
  ddListingsData: DDListingsResponse;
}

const DDListingsModule: React.FC<Props> = ({ ddListingsData }) => {
  const userInfo = useSelector((state: WholeState) =>
    state === undefined ? {} : state.common.user,
  );

  if (!ddListingsData?.listings?.length) return null;

  const developerListing = getDeveloperListing(ddListingsData.listings);
  const agentListings = getAgentListings(ddListingsData.listings);
  const projectName = getProjectName(ddListingsData.listings);

  const developerListingUrl = developerListing
    ? buildDDUrl(
        developerListing.urls?.listing?.desktopByLocales?.th ??
          developerListing.urls?.listing?.desktop,
      )
    : null;

  const listingIdentifier = developerListing
    ? getListingIdentifier(developerListing)
    : '';

  return (
    <>
      {developerListing && developerListing.unitTypes?.length > 0 && (
        <>
          <DDListingsDivider />
          <DDListingsWrapper>
            <DDSectionTitle>ประเภทของยูนิตจากผู้พัฒนาโครงการ</DDSectionTitle>
            <UnitTypesFromDeveloper listing={developerListing} />
            {developerListingUrl && (
              <ViewDetailsButtonWrapper>
                <ViewDetailsButton
                  href={developerListingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() =>
                    trackDDListingClick(
                      userInfo,
                      ADP.DD_LISTINGS,
                      ANALYTICS_FEATURES.DD_LISTINGS_DEVELOPER,
                      listingIdentifier,
                      'view-details',
                    )
                  }
                >
                  ดูเพิ่มเติม & ติดต่อ
                  <ExternalLinkIcon />
                </ViewDetailsButton>
              </ViewDetailsButtonWrapper>
            )}
          </DDListingsWrapper>
        </>
      )}

      {agentListings.length > 0 && (
        <>
          <DDListingsDivider />
          <DDListingsWrapper>
            <DDSectionTitle>
              ประกาศขายในโครงการ {projectName} จากเอเจนท์
            </DDSectionTitle>
            <UnitsFromAgent listings={agentListings} />
          </DDListingsWrapper>
        </>
      )}
    </>
  );
};

export default DDListingsModule;
